var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThumbUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.15 3.905c0-.97.786-1.755 1.755-1.755H12A2.85 2.85 0 0 1 14.85 5v4.15h3.914c2.119 0 3.497 2.23 2.55 4.125l-3.5 7a2.85 2.85 0 0 1-2.55 1.575h-4.018a2.9 2.9 0 0 1-.691-.085l-3.66-.915H5A2.85 2.85 0 0 1 2.15 18v-6A2.85 2.85 0 0 1 5 9.15h2.212l2.473-3.71c.303-.455.465-.989.465-1.535M6.163 10.85H5A1.15 1.15 0 0 0 3.85 12v6c0 .635.515 1.15 1.15 1.15h1.15V11q0-.075.013-.15m1.687 8.486 3.117.78q.137.034.28.034h4.017a1.15 1.15 0 0 0 1.029-.636l3.5-7a1.15 1.15 0 0 0-1.029-1.664H12a.85.85 0 0 1 0-1.7h1.15V5A1.15 1.15 0 0 0 12 3.85h-.095a.055.055 0 0 0-.055.055c0 .882-.261 1.744-.75 2.478l-3.25 4.874z",
  clipRule: "evenodd"
})));
export default SvgThumbUp;